var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { display: "flex", "align-items": "center" },
      style: { height: _vm.containerHeight, margin: _vm.timeMargin + "px" },
    },
    [
      _c("p", { staticStyle: { width: "100%", margin: "auto" } }, [
        _vm._v(_vm._s(_vm.nowDate)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }